import { FunctionalitySelectV2 } from '@frontend/functionality/select';
import { updateField, useAccountRepository } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

import useFunctionalityConstraintDataInput from './functionality-constraint-data-input.controller';

const ID = 'functionality-constraint-data-input';
export interface FunctionalityConstraintDataInputProps {
    dispatch: ThunkDispatch<any, any, Action>;
    formId: string;
    id?: string;
    label?: string;
    className?: string;
    required?: boolean;
}

const FunctionalityConstraintDataInput = (props: FunctionalityConstraintDataInputProps) => {
    const viewProps = useFunctionalityConstraintDataInput(props);
    const {
        store: { currentAccount }
    } = useAccountRepository();

    return (
        <div
            id={ID}
            className='flex w-full flex-row'>
            <FunctionalitySelectV2
                required
                value={viewProps.formValues?.functionality_id ?? null}
                queryParams={{ account_id: currentAccount ?? undefined }}
                onChange={(v) => {
                    props.dispatch(updateField({ formId: props.formId, key: 'data', value: v ? { functionality_id: v } : undefined }));
                }}
            />
        </div>
    );
};

export default FunctionalityConstraintDataInput;
